import { render, staticRenderFns } from "./editfob.vue?vue&type=template&id=3df72c8e"
import script from "./editfob.vue?vue&type=script&lang=js"
export * from "./editfob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports